import type { CoreApiClient } from "../client";
import type { PutPlanningBody } from "../types/planning.type";

export const createPlanningMutations = (api: CoreApiClient) => {
  const { request } = api;

  const update = async (buildingId: string, planning: PutPlanningBody) => {
    await request("put", "/buildings/{buildingId}/plannings", {
      params: { path: { buildingId } },
      body: planning,
    });
  };

  return {
    update,
  };
};
